import useInterventionRepository from "../../../../../repository/b2csdu/useInterventionRepository";
import {useEffect, useRef, useState} from "react";
import isNull from "../../../../../mixin/isNull";
import Body from "../../../../../material/skeleton/Body";
import Footer from "../../../../../material/skeleton/Footer";
import {AddAPhoto, CheckCircle} from "@mui/icons-material";
import {Alert, Button, CircularProgress, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import useHelper from "../../../../../use/useHelper";
import SlideFileCustom from "../../../../../material/file/SlideFileCustom";
import FileData from "../../../../../material/file/FileData";
import useAlert from "../../../../../use/useAlert";
import useOrderRepository from "../../../../../repository/b2csdu/useOrderRepository";
import parameter from "../../../../../enum/parameter";
import Compressor from 'compressorjs';

export default function ({interventionId, orderId}) {
    const alert = useAlert();
    const helper = useHelper();
    const orderRepository = useOrderRepository()
    const interventionRepository = useInterventionRepository();
    /** @type Intervention */
    const intervention = interventionRepository.findOneById(interventionId).select();
    /** @type Order */
    const order = orderRepository.findOneById(orderId).select();
    const [loading, setLoading] = useState(false);
    const [compressInProgress, setCompressInProgress] = useState(false);
    const pictureInput = useRef();
    const [pictureResult, setPictureResult] = useState(null);
    const [preTaxAmount, setPreTaxAmount] = useState(null);

    useEffect(() => {
        interventionRepository.findOneById(interventionId).exec();
        orderRepository.findOneById(orderId).exec();
    }, []);

    const handleTakePictureClick = () => pictureInput.current.click();

    const handleUpload = e => {
        setCompressInProgress(true);
        const file = e.target.files[0];

        if (isNull(file)) {
            setCompressInProgress(false);
            return;
        }

        if (file.type.startsWith("image")) {
            const options = {
                quality: 0.3,

                // Compression success callback
                success: async result => {
                    setPictureResult(await helper.inputFileToRequestFile(result));
                    setCompressInProgress(false);
                },
                error: () => {
                    setLoading(false);
                }
            };

            new Compressor(file, options);
        } else {
            const reader = new FileReader();

            reader.onload = ((f) => (e) => {
                let contentType = file.type;
                let content = e.target.result.replace("data:" + contentType + ";base64,", "");

                setPictureResult({"content": content, "content-type": contentType});
                setCompressInProgress(false);
            })(file);
            reader.readAsDataURL(file);
        }

    }

    const nextStep = async () => {
        if (isNull(pictureResult)) {
            alert.warning("Merci de fournir votre facture");
            return;
        }

        if (isNull(preTaxAmount)
            || parseInt(preTaxAmount) <= 0) {
            alert.warning("Merci de renseigner le montant H.T. de votre facture");
            return;
        }

        setLoading(true);

        let res = await interventionRepository.update(interventionId, "invoice_file", {
            uploaded_file: {
                intervention_invoice_file: pictureResult
            }
        });

        if (!res) {
            setLoading(false);
            return;
        }

        res = await interventionRepository.update(interventionId, "invoice_pre_tax_amount", {
            intervention: {
                invoice_pre_tax_amount: preTaxAmount
            }
        });

        if (!res) {
            setLoading(false);
            return;
        }
    }

    if (isNull(intervention)) return null;

    return (
        <>
            <Body sx={{px: 2}}>
                <Box mt={2} data-test="order-comment">
                    <Alert severity={"info"}>
                        Descriptif mission : {order?.getOrderComment()}
                    </Alert>
                </Box>
                <Box mt={5}>
                    <Button
                        startIcon={compressInProgress ? <CircularProgress size={20} color={"inherit"}/> : <AddAPhoto/>}
                        variant={"contained"}
                        onClick={handleTakePictureClick}
                        disabled={compressInProgress}
                        fullWidth
                    >
                        {
                            !compressInProgress
                                ? "Prendre votre facture en photo"
                                : "Compression de l'image"
                        }
                    </Button>
                    <input
                        ref={pictureInput}
                        style={{display: "none"}}
                        type={"file"}
                        accept="*/*"
                        onChange={handleUpload}
                        data-test="input-file"
                    />
                </Box>
                <Box mt={5}>
                    <TextField
                        fullWidth
                        type={"number"}
                        label={"Saisir le montant H.T. de votre facture"}
                        onChange={e => setPreTaxAmount(e.target.value)}
                        name={"invoice-amount"}
                    />
                </Box>
                <Box mt={2}>
                    {
                        !isNull(pictureResult)
                            ? (
                                <SlideFileCustom
                                    key={JSON.stringify(pictureResult)}
                                    ids={[0]}
                                    getFile={async () => new FileData("name", pictureResult.content, pictureResult["content-type"])}
                                    disableDownload={true}
                                />
                            )
                            : null
                    }
                </Box>
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    onClick={nextStep}
                    disabled={loading || isNull(pictureResult) || isNull(preTaxAmount)}
                    data-test="button-next-step"
                >
                    J'ai terminé l'intervention
                </Button>
            </Footer>
        </>
    )
}